import { routes } from '../api/routes';
import store from '../store';
import { getLocalStorageVar } from '../util';

const {
	productAPIUrl,
	product,
	localStorageVar,
	showDebuggerConsoles,
} = routes;

const getJWTSSO = () => {
	const storeObj = store.getState();
	let jwt = storeObj && storeObj.user && storeObj.user.userDetails && storeObj.user.userDetails.jwt;
	let sso = storeObj && storeObj.user && storeObj.user.userDetails && storeObj.user.userDetails.sso;
	// If jwt not available from store then check it once from local storage
	showDebuggerConsoles && console.log("###### getJWTSSO -> storeObj.user.userDetails : ", storeObj.user.userDetails);
	if (!jwt) {
		const localStrogeObj = getLocalStorageVar(localStorageVar);
		showDebuggerConsoles && console.log("###### getJWTSSO -> !jwt -> localStrogeObj : ", localStrogeObj);
		if (localStrogeObj) {
			jwt = localStrogeObj.jwt;
			showDebuggerConsoles && console.log("###### getJWTSSO -> !jwt -> localStrogeObj -> jwt : ", jwt);
		}
	}
	// If jwt not available from store then check it once from local storage
	if (!sso) {
		const localStrogeObj = getLocalStorageVar(localStorageVar);
		showDebuggerConsoles && console.log("###### getJWTSSO -> !sso -> localStrogeObj : ", localStrogeObj);
		if (localStrogeObj) {
			sso = localStrogeObj.sso;
			showDebuggerConsoles && console.log("###### getJWTSSO -> !sso -> localStrogeObj -> sso : ", sso);
		}
	}
	sso = sso?`|${sso}`:'';
	return {
		jwt,
		sso
	};
}

/*
	Send Request and get response
	-----------------------------
	e.g
	url: 'https://8yrrju0nt9.execute-api.us-east-1.amazonaws.com/dev/'
	path: 'orders'
	key: {
		"x-api-key": "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
	}
	method: 'POST' or 'GET' or 'HYBRID'
	payload:
		if method is 'GET', then payload will contains queryString, e.g 'param1=value1&param2=value2'
		if method is 'POST', then payload will contains payload in json format { param1: 'value1', param2: 'value2' }
		if method is 'HYBRID', then hybridQueryParams contains query string like 'param1=value1&param2=value2' and payload in json format { param1: 'value1', param2: 'value2' }
*/
export function sendRequest(url, path, key, method, payload, hybridQueryParams) {
	const { jwt, sso } = getJWTSSO();
	showDebuggerConsoles && console.log("######### sendRequest: func params: ", url, path, key, method, payload, hybridQueryParams);
    return new Promise((resolve, reject) => {
		var finalUrl = url + path;
        let options = {
            method: method,
            headers: {
                "x-api-key": key["x-api-key"],
				"Authorization": `${jwt}${sso}`,
				"Content-Type": "application/json"
            }
        };
		if(!key) {
			delete options.headers["x-api-key"];
		}
		if(!jwt) {
			delete options.headers["Authorization"];
		}
		if(method === 'POST' || method === 'PUT' || method === 'DELETE') {
			options = {
				...options,
				body: JSON.stringify(payload)
			};
		} else if(method === 'GET') {
			// Handle null or empty payload
			if(payload && payload !== 'null' && payload !== '') {
				finalUrl += "?" + payload;
			}
		}

		// Add cache-busting parameter to prevent browser caching issues
		const querySeparator = finalUrl.indexOf('?') > -1 ? '&' : '?';
		finalUrl = finalUrl.trim();
		finalUrl += `${querySeparator}t=${Date.now()}`;

		if(hybridQueryParams && hybridQueryParams !== '') {
			const hybridSeparator = finalUrl.indexOf('?') > -1 ? '&' : '?';
			finalUrl += `${hybridSeparator}${hybridQueryParams}`;
		}
        fetch(finalUrl, options).then((response) => {
            if (response.status === 200) {
                response.json().then(response => {
                    resolve(response);
                });
            } else if (response.status === 401) {
				showDebuggerConsoles && console.log("#### sendRequest Page: ", response);
                reject(response);
            } else {
                response.json().then(outputJSON => {
                    resolve({
                        error: true,
                        messageOptions: {
                            message: outputJSON.message,
                            level: 'success'
                        }
                    });
                }).catch((err) => {
                    reject(err);
                });
            }
        }).catch((err) => {
            reject(err);
        });
    });
}


/**
 * function for Get Result of entered keyword of Product Number Auto suggest list
 * also it will fetch data from dropdown of product line and filters
 * @return {Promise <Object, Error>}
 * Type of Search : Whether its keyword search of product number or product line dropdown
 */
export function fetchProductNumberKeywordResult(searchStr, filters, params, typeOfSearch, pageSize, whichSearch, isPricingAccess, isPriceDiscountAccess) {
	const { jwt, sso } = getJWTSSO();
	showDebuggerConsoles && console.log("######### fetchProductNumberKeywordResult: func params: ", searchStr, filters, params, typeOfSearch, pageSize, whichSearch, isPricingAccess, isPriceDiscountAccess);
	return new Promise((resolve, reject) => {
		const options = {
			method: 'GET',
			headers: {
				"Authorization": `${jwt}${sso}`
            }
		};
		if(!jwt) {
			delete options.headers["Authorization"];
		}
	    let url = "";
		if(typeOfSearch === "product-number") {
			searchStr = searchStr?(searchStr.trim()):'';
		    searchStr = searchStr.replace(/ /g, "+");
			url = `${productAPIUrl}${product.getSearchResult.path}?keyword=${searchStr}&page=search`
		} else if(typeOfSearch === "product-line") {
			filters = filters?filters.replace("?N=",""):"";
			url = `${productAPIUrl}${product.getSearchResult.path}?categoryId=${filters}`
		} else if(typeOfSearch === "quote-models") {
			searchStr = searchStr.replace(/ /g, "+");
			url = `${productAPIUrl}${product.getSearchResult.path}?&keyword=${searchStr}`;
		}
		if(isPriceDiscountAccess) {
			url += `&requestType=PriceDiscounts&custId=${params.accountId}&region=${params.region}&custClass=${params.custClass}`;
		} else if(isPricingAccess){
			url += `&requestType=Price&region=${params.region}`;
		} else {
			url += '&requestType=getItems';
		}
	    fetch(url, options).then((response) => {
			if (response.status === 200) {
		        response.json().then(result => {
		        	resolve(result.responseObject);
		        });
			} else {
		        response.json().then(outputJSON => {
					resolve({
						error: true,
						messageOptions: {
							message: outputJSON.message,
							level: 'success'
						}
					});
		        }).catch((err) => {
		        	reject(err);
		        });
			}
	    }).catch((err) => {
			reject(err);
	    });
	});
}


// WEBPACK FOOTER //
// ./src/App/redux/api/sendRequest.js